import React, { useState } from 'react';
import './Onboarding.css';

const STEPS = [
  {
    emoji: '👋',
    title: 'Welcome to Hangrily!',
    desc: "Stop arguing about where to eat. We'll help you decide in seconds — just swipe.",
  },
  {
    emoji: '🍽️',
    title: 'Pick a Mode',
    desc: 'Go Solo for a quick personal pick, Couple to swipe with your partner in real time, or Group to let friends vote together.',
  },
  {
    emoji: '👆',
    title: 'Swipe to Decide',
    desc: 'Set your preferences (cuisine, distance, price), then swipe right on restaurants you like and left on ones you don\'t.',
  },
  {
    emoji: '🎉',
    title: 'Get Your Match',
    desc: 'We crunch the votes and pick the winner. Save your favorites, track your history, and never argue about food again.',
  },
];

export default function Onboarding({ onComplete }) {
  const [step, setStep] = useState(0);
  const current = STEPS[step];
  const isLast = step === STEPS.length - 1;

  function next() {
    if (isLast) {
      localStorage.setItem('hangrily_onboarded', '1');
      onComplete();
    } else {
      setStep(step + 1);
    }
  }

  function skip() {
    localStorage.setItem('hangrily_onboarded', '1');
    onComplete();
  }

  return (
    <div className="ob-overlay">
      <div className="ob-card" key={step}>
        <span className="ob-emoji">{current.emoji}</span>
        <h1 className="ob-title">{current.title}</h1>
        <p className="ob-desc">{current.desc}</p>

        <div className="ob-dots">
          {STEPS.map((_, i) => (
            <span key={i} className={`ob-dot ${i === step ? 'ob-dot--active' : ''}`} />
          ))}
        </div>

        <button className="ob-next" onClick={next}>
          {isLast ? "Let's Go!" : 'Next'}
        </button>

        {!isLast && (
          <button className="ob-skip" onClick={skip}>
            Skip intro
          </button>
        )}
      </div>
    </div>
  );
}
